import React from 'react';
import { Users, TrendingUp, Palette, Video, Target, Award } from 'lucide-react';

const CreativeLeadership = () => {
  const keyAreas = [
    { icon: Palette, title: 'Creative Direction', color: 'text-gold' },
    { icon: Users, title: 'Team Leadership', color: 'text-magenta' },
    { icon: TrendingUp, title: 'Campaign Development', color: 'text-gold' },
    { icon: Video, title: 'Visual Storytelling', color: 'text-magenta' },
    { icon: Target, title: 'Production Management', color: 'text-gold' },
    { icon: Award, title: 'Brand Development', color: 'text-magenta' }
  ];

  return (
    <section className="py-24 px-6 bg-zinc-950 fade-in-section">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="font-playfair text-5xl md:text-6xl font-bold mb-8">
              Leading <span className="text-gold">Creative Teams</span>
            </h2>
            <div className="space-y-6 text-lg text-gray-300 leading-relaxed">
              <p>
                My role goes beyond design. I lead teams of designers, photographers, and 
                video editors, while also producing content myself. I focus on creating clear 
                creative direction while managing both the people and production required to 
                bring ideas to life.
              </p>
              <p>
                I collaborate with marketing strategists and cross-functional teams to ensure 
                projects move efficiently from concept through execution while maintaining a 
                strong visual standard.
              </p>
            </div>
          </div>
          
          <div>
            <h3 className="text-2xl font-bold mb-8 text-gold tracking-wide">KEY AREAS</h3>
            <div className="grid grid-cols-2 gap-6">
              {keyAreas.map((area, index) => {
                const Icon = area.icon;
                return (
                  <div 
                    key={index}
                    className="group p-6 border border-gray-800 hover:border-gold transition-all duration-300"
                  >
                    <Icon className={`${area.color} mb-4 group-hover:scale-110 transition-transform duration-300`} size={32} />
                    <h4 className="font-medium text-lg">{area.title}</h4>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CreativeLeadership;